import type { Group } from '@domain/person';
import { type FunctionComponent } from 'react';
import { EuiButtonIcon, EuiToolTip } from '@elastic/eui';
import { useRemoveFromGroup } from '@data/group-mutations';

interface RemoveGroupProps {
  idnumber: string;
  group: Group;
}

const RemoveGroup: FunctionComponent<RemoveGroupProps> = props => {
  const { idnumber, group } = props;
  const [remove, { loading }] = useRemoveFromGroup();

  const handleClick = () => {
    remove(idnumber, group.name);
  };

  return (
    <EuiToolTip
      content={
        group.virtual
          ? 'Controlled by another system'
          : `Remove ${group.name} permission`
      }>
      <EuiButtonIcon
        iconType="cross"
        color="danger"
        aria-label={group.virtual ? '' : `Remove ${group.name} permission`}
        isLoading={loading}
        isDisabled={group.virtual}
        onClick={handleClick}
      />
    </EuiToolTip>
  );
};

export default RemoveGroup;
